export default {
  searchFilter: {
    search_text: ''
  },
  searchHistory: [],
  searchResults: [],
  archivedDataSearchText: ''
}
